import { render, staticRenderFns } from "./associationManagement.vue?vue&type=template&id=b4aa4bbc&scoped=true&"
import script from "./associationManagement.vue?vue&type=script&lang=js&"
export * from "./associationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aa4bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4aa4bbc')) {
      api.createRecord('b4aa4bbc', component.options)
    } else {
      api.reload('b4aa4bbc', component.options)
    }
    module.hot.accept("./associationManagement.vue?vue&type=template&id=b4aa4bbc&scoped=true&", function () {
      api.rerender('b4aa4bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/associationManagement/associationManagement.vue"
export default component.exports